// gutenslider nodes
const targetNodes = document.querySelectorAll('.wp-block-eedee-block-gutenslider[class*="speed-"] .swiper');

// mutation flag
let mutationHappened = false;

// create observer for DOM node mutations
const observer = new MutationObserver((mutationsList) => {
    if ( ! mutationHappened ) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const element = mutation.target;
                
                // check if swiper was initialized
                if (element.classList.contains('swiper-initialized')) {
                    const params = element.swiper.params;
                    
                    // find matches with 'speed-' classnode
                    let match = element.parentElement.parentElement.className.match(/speed-(\d+)/);

                    // Destruct an old swiper instance
                    if (element.swiper) {
                        element.swiper.destroy(false, false);
                    }

                    if ( match ) {
                        params.speed = parseInt(match[1]);

                        new Swiper(element, params);
                    }
                    
                    mutationHappened = true;
                }
            }
        }
    }
});

// assign observer to Gutensliders
if ( ! mutationHappened ) {
    targetNodes.forEach(function (value) {
        observer.observe(value, { attributes: true });
    });
}